





























































































































































































































































































































































































































































































































































































import BaseComponent from '@/core/base.component';
import { AnalysisTabListDto } from '@/dto';
import AnalysisTabService from '@/services/analysis/analysis-tab.service';
import DashboardPieChart from '../../dashboard/add-on/DashboardPieChart.vue';
import DashboardBarChart from '../../dashboard/add-on/DashboardBarChart.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ReverseQueryParamMapper } from '@/core';
@Component({
  name: 'AnalysisPopulation',
  components: {
    DashboardPieChart,
    DashboardBarChart,
  },
})
export default class AnalysisPopulation extends BaseComponent {
  @Prop() bdongCode!: string;
  private analysisTabSearchDto = new AnalysisTabListDto();
  private residentTotalCount = null;
  private residentGenderCountData = null;
  private residentGenderRatioData = null;
  private residentAgeGroupCountData = null;
  private residentAgeGroupRatioData = null;
  private residentialTotalCountData = null;
  private residentialCountData = null;
  private residentialRatioData = null;
  private employeeTotalCount = null;
  private movingPopulationTotalCount = null;
  private movingPopulationGenderData = null;
  private movingPopulationAgeData = null;
  private dataLoadingResident = true;
  private dataLoadingResidential = true;
  private dataLoadingEmplyee = true;
  private dataLoadingMovingPopulation = true;
  private barOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };

  findPopulationResidentCount() {
    AnalysisTabService.findPopulationResidentCount(
      this.analysisTabSearchDto,
    ).subscribe(res => {
      if (res) {
        this.residentTotalCount = res.data.residentialPopulationCount;
      }
    });
  }

  findPopulationGenderRatio() {
    AnalysisTabService.findPopulationGenderRatio(
      this.analysisTabSearchDto,
    ).subscribe(res => {
      if (res) {
        this.residentGenderCountData = res.data[0];
        this.residentGenderRatioData = res.data[1];
      }
    });
  }

  findAgeGroupRatio() {
    this.dataLoadingResident = true;
    AnalysisTabService.findAgeGroupRatio(this.analysisTabSearchDto).subscribe(
      res => {
        if (res) {
          this.dataLoadingResident = false;
          this.residentAgeGroupCountData = res.data[0];
          this.residentAgeGroupRatioData = res.data[1];
        }
      },
    );
  }

  findPopulationResidentialRatio() {
    this.dataLoadingResidential = true;
    AnalysisTabService.findPopulationResidentialRatio(
      this.analysisTabSearchDto,
    ).subscribe(res => {
      if (res) {
        this.dataLoadingResidential = false;
        this.residentialTotalCountData = res.data[0];
        this.residentialCountData = res.data[1].datasets[0].data;
        this.residentialRatioData = res.data[1];
      }
    });
  }

  findPopulationEmployeeCount() {
    this.dataLoadingEmplyee = true;
    AnalysisTabService.findPopulationEmployeeCount(
      this.analysisTabSearchDto,
    ).subscribe(res => {
      if (res) {
        this.dataLoadingEmplyee = false;
        this.employeeTotalCount = res.data.totalCount;
      }
    });
  }
  findMovingPopulationCount() {
    AnalysisTabService.findMovingPopulationCount(
      this.analysisTabSearchDto,
    ).subscribe(res => {
      if (res) {
        this.movingPopulationTotalCount = res.data.totalCount;
      }
    });
  }

  findMovingPopulationGenderAndAgeRatio() {
    this.dataLoadingMovingPopulation = true;
    AnalysisTabService.findMovingPopulationGenderAndAgeRatio(
      this.analysisTabSearchDto,
    ).subscribe(res => {
      if (res && res.data) {
        this.dataLoadingMovingPopulation = false;
        if (res.data[0]) this.movingPopulationGenderData = res.data[0];
        if (res.data[1]) this.movingPopulationAgeData = res.data[1];
      }
    });
  }

  findAnalysisPopulation() {
    this.findPopulationResidentCount();
    this.findPopulationGenderRatio();
    this.findAgeGroupRatio();
    this.findPopulationResidentialRatio();
    this.findPopulationEmployeeCount();
    this.findMovingPopulationCount();
    this.findMovingPopulationGenderAndAgeRatio();
  }

  created() {
    this.analysisTabSearchDto.bdongCode = this.bdongCode;
    this.findAnalysisPopulation();
  }
}
